var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-icon-arrow-white';
                    var viewUrl = 'gfx/sprite.svg#view-icon-icon-arrow-white';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 13',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };